import {ContainerDataRetriever} from "FormBuilder/Core/FormBuilder.Model";
import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {SingleEvent} from "shared/core/Events/SingleEvent";


export class PriceManager {
    public TotalUpdated:SingleEvent<number>;
    public FieldPriceUpdated:SingleEvent<FBFieldBaseModel>;
    public ProductPrice:number=0;
    private OptionsUnitPrice:number=0;
    private GrandTotal:number;
    private Quantity:number=1;
    private OptionsTotal:number=0;


    constructor(public FormBuilder:ContainerDataRetriever){
        this.TotalUpdated=new SingleEvent();
        this.GrandTotal=0;
        this.Quantity=0;
        this.OptionsTotal=0;
        this.OptionsUnitPrice=0;
        this.FieldPriceUpdated=new SingleEvent();
        this.FormBuilder.ProductPriceChanged.Subscribe(this,()=>{
            this.RecalculateTotal(null);
        });
        this.RecalculateTotal=this.RecalculateTotal.bind(this);

    }


    public CalculateProductPrice(){
        let regularPrice=this.FormBuilder.GetProductPrice();
        let salePrice=this.FormBuilder.GetSalePrice();

        salePrice=parseFloat(salePrice.toString());
        regularPrice=parseFloat(regularPrice.toString());

        if(isNaN(salePrice))
            salePrice=0;
        if(isNaN(regularPrice))
            regularPrice=0;

        if(this.FormBuilder.GetSalePrice()=='')
            this.ProductPrice=regularPrice;
        else
            this.ProductPrice=salePrice;
    }


    public AddField(field:FBFieldWithPriceBaseModel){
        field.calculator.PriceUpdated.Subscribe(this,this.RecalculateTotal);
        this.FieldPriceUpdated.Publish(field);
        this.RecalculateTotal(field);
    }

    public RemoveField(field:FBFieldWithPriceBaseModel)
    {
        field.calculator.PriceUpdated.Unsubscribe(this);
        this.RecalculateTotal(field);
    }



    private RecalculateTotal(fieldUpdated:FBFieldBaseModel) {

        this.CalculateProductPrice();
        if(fieldUpdated!=null)
            this.FieldPriceUpdated.Publish(fieldUpdated);
        this.OptionsUnitPrice=this.GetFields().reduce((previous,current)=> previous+current.calculator.GetPrice(),0);
        this.OptionsTotal=this.OptionsUnitPrice*this.Quantity;

        let currentTotal=(this.OptionsUnitPrice+this.ProductPrice)*this.Quantity;
        if(currentTotal!=this.GrandTotal) {
            this.GrandTotal=currentTotal;
            this.TotalUpdated.Publish(this.GrandTotal);
        }
    }

    public GetFields():FBFieldWithPriceBaseModel[]{
        return this.FormBuilder.ContainerManager.GetFields(false,false,false).filter(x=>x instanceof FBFieldWithPriceBaseModel) as any;
    }

    public GetPriceIgnoringFields(fields:FBFieldBaseModel[])
    {
        let total=0;
        for(let field of this.GetFields())
            if(!field.calculator.IsDynamic()&& !fields.find(x=>x.Options.Id==field.Options.Id)) {
                total += field.calculator.GetPrice();
            }
        return total;

    }

    public GetPrice(field:FBFieldBaseModel)
    {
        let fieldToUse=this.GetFields().find(x=>x==field);
        if(fieldToUse==null)
            return 0;
        return fieldToUse.calculator.GetPrice();


    }

    GetOptionsUnitPrice(){
        return this.OptionsUnitPrice;
    }

    GetOptionsTotal(){
        return this.OptionsTotal;
    }

    GetGrandTotal(){
        return this.GrandTotal;
    }

    GetQuantity(){
        return this.Quantity;
    }

    UpdateQuantity(quantity: number) {
        this.Quantity=quantity;
        this.RecalculateTotal(null);
    }
}